module.exports = __webpack_public_path__ + "static/media/Localvore_Reverse.e80d4b19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Localvore_Reverse.png
// module id = 921
// module chunks = 4